import { useAccount } from "#contexts/AccountContext"

/**
 * Hook to check if the current user can perform mutations (owner or admin)
 * @returns {boolean} true if user is owner or admin, false otherwise
 */
export function useCanPerformMutations(): boolean {
  const { currentAccount } = useAccount()

  if (!currentAccount) {
    return false
  }

  const role = currentAccount.meta?.pivot_role?.toLowerCase()
  const isOwner = currentAccount.meta?.pivot_owner === true || role === "owner"
  const isAdmin = role === "admin"

  return isOwner || isAdmin
}
